export const SECONDS_PER_ROUND = 6;
